import { render, staticRenderFns } from "./ProjectTaskTab.vue?vue&type=template&id=759650a4"
import script from "./ProjectTaskTab.vue?vue&type=script&lang=js"
export * from "./ProjectTaskTab.vue?vue&type=script&lang=js"
import style0 from "./ProjectTaskTab.vue?vue&type=style&index=0&id=759650a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports